import * as React from "react";
import { Dispatch, useEffect, useReducer } from "react";
import produce from "immer";
import copy from "../../data/copy/jela.json";
import { useAppState } from "..";

const initialState = { copy: copy };
export const CopyStateContext = React.createContext<ICopyProviderState>(
  initialState
);
export const CopyDispatchContext = React.createContext<
  Dispatch<any> | undefined
>(undefined);

const copyReducer = produce((draft, action) => {
  switch (action.type) {
    case "INIT":
      // @todo Dynamic copy import.
      // Currently hardcoded to jela.json
      draft.copy = copy;
      break;
    default:
      throw new Error();
  }
});

interface ICopyProviderState {
  copy: any;
}
const CopyProvider: React.FC = props => {
  const { copy } = useAppState();
  const [state, dispatch] = useReducer(copyReducer, initialState);

  useEffect(() => {
    if (copy) {
      dispatch({
        type: "INIT",
        value: copy
      });
    }
  }, [copy]);

  return (
    <CopyStateContext.Provider value={state}>
      <CopyDispatchContext.Provider value={dispatch}>
        {props.children}
      </CopyDispatchContext.Provider>
    </CopyStateContext.Provider>
  );
};

function useCopy(key: string) {
  const context = useCopyState();

  return { ...context.copy[key] };
}

function useCopyState() {
  const context = React.useContext(CopyStateContext);

  if (context === undefined) {
    throw new Error("useCopyState must be used within an CopyProvider");
  }

  return context;
}

function useCopyDispatch() {
  const context = React.useContext(CopyDispatchContext);

  if (context === undefined) {
    throw new Error("useCopyState must be used within an CopyProvider");
  }

  return context;
}

export { CopyProvider, useCopyState, useCopyDispatch, useCopy };
